/* Dropdayz — prijsschuif met verdeling.

   Zelfstandig: bouwt zijn eigen HTML, raakt de Liquid niet aan. Leest de twee
   number-inputs die Shopify's prijsfilter al rendert, verbergt ze, en schrijft
   de gekozen waardes daar terug. Daardoor blijft alles eromheen werken (URL,
   chips, formulier) en zie je zonder JavaScript gewoon de originele vakjes.

   DATA: /collections/<handle>?view=prices (templates/collection.prices.liquid).
   products.json is 646 KB per 250 producten; deze feed is ~300 bytes per
   pagina. Pas ophalen als de drawer voor het eerst opengaat, daarna onthouden.

   SCHAAL: de duurste sneaker zou 95% van de schuif leegtrekken, dus de schuif
   loopt tot circa het 95e percentiel en de laatste stand betekent "en hoger":
   dan sturen we geen bovengrens mee en blijft die ene dure vindbaar.

   HERBOUWEN: het drawerlichaam wordt na elke filterwissel vervangen door verse
   server-HTML. Een MutationObserver merkt dat en bouwt de schuif opnieuw op
   met de stand die de server teruggaf.
*/
(function () {
  'use strict';

  var BUCKETS = 26;
  var prices = null;
  var loading = false;
  var building = false;

  function priceBox() { return document.querySelector('.ddz-fprice'); }

  function fields() {
    var box = priceBox();
    if (!box) return null;
    var n = box.querySelectorAll('input[type=number]');
    return n.length === 2 ? { lo: n[0], hi: n[1] } : null;
  }

  function load(done) {
    if (prices) { done(); return; }
    if (loading) return;
    loading = true;
    var base = window.location.pathname + '?view=prices&page=';
    window.fetch(base + '1')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var first = JSON.parse(t.trim());
        var all = first.p || [];
        var jobs = [];
        var pages = Math.min(first.pages || 1, 12);
        for (var i = 2; i <= pages; i++) {
          jobs.push(window.fetch(base + i).then(function (r) { return r.text(); }).then(function (x) { return JSON.parse(x.trim()).p || []; }));
        }
        return Promise.all(jobs).then(function (rest) {
          for (var k = 0; k < rest.length; k++) all = all.concat(rest[k]);
          prices = all;
          loading = false;
          done();
        });
      })
      .catch(function () { loading = false; });
  }

  function niceStep(x) {
    var steps = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1000];
    for (var i = 0; i < steps.length; i++) { if (x <= steps[i]) return steps[i]; }
    return 2000;
  }

  function build() {
    var box = priceBox();
    var f = fields();
    if (!box || !f || !prices || prices.length < 4) return;

    var group = box.parentNode;
    var old = group.querySelector('.ddz-fslider');
    if (old) old.parentNode.removeChild(old);

    var sorted = prices.slice().sort(function (a, b) { return a - b; });
    var p95 = sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * 0.95))];
    var step = niceStep(Math.ceil(p95 / BUCKETS));
    var counts = [];
    var i;
    for (i = 0; i < BUCKETS; i++) counts.push(0);
    for (i = 0; i < sorted.length; i++) {
      counts[Math.min(BUCKETS - 1, Math.floor(sorted[i] / step))]++;
    }
    var peak = 0;
    for (i = 0; i < BUCKETS; i++) { if (counts[i] > peak) peak = counts[i]; }
    if (peak === 0) return;

    var bars = '';
    for (i = 0; i < BUCKETS; i++) {
      var h = counts[i] === 0 ? 2 : Math.round(8 + 92 * Math.pow(counts[i] / peak, 0.55));
      bars += '<span class="ddz-fslider__bar" style="height:' + h + '%"></span>';
    }

    var wrap = document.createElement('div');
    wrap.className = 'ddz-fslider';
    wrap.innerHTML =
      '<div class="ddz-fslider__hist">' + bars + '</div>' +
      '<div class="ddz-fslider__track">' +
        '<span class="ddz-fslider__fill"></span>' +
        '<input type="range" class="ddz-fslider__r ddz-fslider__r--min" min="0" max="' + BUCKETS + '" step="1" value="0" aria-label="Laagste prijs">' +
        '<input type="range" class="ddz-fslider__r ddz-fslider__r--max" min="0" max="' + BUCKETS + '" step="1" value="' + BUCKETS + '" aria-label="Hoogste prijs">' +
      '</div>' +
      '<div class="ddz-fslider__out"></div>';
    group.insertBefore(wrap, box);
    box.classList.add('is-replaced');

    var rMin = wrap.querySelector('.ddz-fslider__r--min');
    var rMax = wrap.querySelector('.ddz-fslider__r--max');
    var fill = wrap.querySelector('.ddz-fslider__fill');
    var out = wrap.querySelector('.ddz-fslider__out');
    var barEls = wrap.querySelectorAll('.ddz-fslider__bar');

    var lo = parseFloat(f.lo.value);
    var hi = parseFloat(f.hi.value);
    var loIdx = isNaN(lo) ? 0 : Math.max(0, Math.min(BUCKETS, Math.round(lo / step)));
    var hiIdx = isNaN(hi) ? BUCKETS : Math.max(0, Math.min(BUCKETS, Math.round(hi / step)));
    if (hiIdx <= loIdx) hiIdx = Math.min(BUCKETS, loIdx + 1);
    rMin.value = loIdx;
    rMax.value = hiIdx;

    function euro(n) { return '€ ' + n.toLocaleString('nl-NL'); }

    function paint() {
      var a = (loIdx / BUCKETS) * 100;
      var b = (hiIdx / BUCKETS) * 100;
      fill.style.left = a + '%';
      fill.style.width = (b - a) + '%';
      for (var j = 0; j < barEls.length; j++) {
        barEls[j].classList.toggle('is-on', j >= loIdx && j < hiIdx);
      }
      if (loIdx === 0 && hiIdx === BUCKETS) {
        out.innerHTML = '<span>Alle prijzen</span>';
      } else {
        var top = hiIdx === BUCKETS ? euro(BUCKETS * step) + '+' : euro(hiIdx * step);
        out.innerHTML = '<b>' + euro(loIdx * step) + '</b><span>tot</span><b>' + top + '</b>';
      }
    }

    function commit() {
      f.lo.value = loIdx > 0 ? String(loIdx * step) : '';
      f.hi.value = hiIdx < BUCKETS ? String(hiIdx * step) : '';
    }

    function onDrag() {
      var a = parseInt(rMin.value, 10);
      var b = parseInt(rMax.value, 10);
      if (a >= b) {
        if (this === rMin) { a = b - 1; rMin.value = a; }
        else { b = a + 1; rMax.value = b; }
      }
      loIdx = Math.max(0, a);
      hiIdx = Math.min(BUCKETS, b);
      paint();
      commit();
    }

    function onRelease() {
      f.lo.dispatchEvent(new Event('input', { bubbles: true }));
    }

    rMin.addEventListener('input', onDrag);
    rMax.addEventListener('input', onDrag);
    rMin.addEventListener('change', onRelease);
    rMax.addEventListener('change', onRelease);

    paint();
  }

  function safeBuild() {
    if (building) return;
    building = true;
    try { build(); } catch (e) {}
    window.setTimeout(function () { building = false; }, 0);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-ddz-filter-open]')) load(safeBuild);
  });

  var body = document.querySelector('[data-ddz-filter-body]');
  if (body && 'MutationObserver' in window) {
    new MutationObserver(function () { if (prices) safeBuild(); }).observe(body, { childList: true });
  }
})();
